<template>
  <v-layout wrap pa-3>
      <v-flex sm4 pr-2>
        <v-text-field clearable v-model="adminFilterSearch" :label="$t('Admin.Search')" append-icon="mdi-magnify" />                
      </v-flex>
      <v-flex sm4 pl-2 pr-2 v-if="umbTypes.length > 1">
        <v-autocomplete :menu-props="{ closeOnClick: false, openOnClick: false }" hide-no-data browser-autocomplete="disable" dense small-chips deletable-chips hide-selected multiple v-model="adminMesureTypeUmtFilterIds" clearable clear-icon="mdi-close" item-text="libelle" item-value="id" :items="umbTypes" :label="$t('Admin.MesureType.List.FilterUmbType')"></v-autocomplete>
      </v-flex>
      <v-flex sm4 pl-2 v-if="mesureUnites.length > 1">
        <v-autocomplete :menu-props="{ closeOnClick: false, openOnClick: false }" hide-no-data browser-autocomplete="disable" dense small-chips deletable-chips hide-selected multiple v-model="adminMesureTypeMesureUnitFilterIds" clearable clear-icon="mdi-close" :item-text="(it) => {return `${it.MUT_LIBELLE} (${it.MUT_SYMBOL})` }" item-value="id" :items="mesureUnites" :label="$t('Admin.MesureType.List.FilterMesureUnit')"></v-autocomplete>
      </v-flex>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { AloDbUser } from '@/models/alodb/AloDbUser';
import { FilterUser } from '@/models/filter/FilterUser';


@Component({
  name: 'AdminMesureTypeFilter'
})
export default class AdminMesureTypeFilter extends Vue {  

  //recupere les umbTypes possédants au moins un utilisateur
  get umbTypes() {
    return this.$store.myGetters.umbTypes.filter(e => this.$store.myGetters.mesureTypes.findIndex(m => m.UMT_ID == e.UMT_ID) > -1)
  }

  get mesureUnites() {
    return this.$store.myGetters.mesureUnites.filter(e => this.$store.myGetters.mesureTypes.findIndex(m => m.MUT_ID == e.MUT_ID) > -1)
  }
  
  get adminMesureTypeUmtFilterIds() {
    return this.$store.myGetters.adminMesureTypeFilter.umtIds
  }
  set adminMesureTypeUmtFilterIds(value) {
    this.$store.myActions.MESURETYPE_UPDATE_FILTER_ADM({
      umtIds:value
    })
  }  

  get adminMesureTypeMesureUnitFilterIds() {
    return this.$store.myGetters.adminMesureTypeFilter.mesureUniteIds
  }
  set adminMesureTypeMesureUnitFilterIds(value) {
    this.$store.myActions.MESURETYPE_UPDATE_FILTER_ADM({
      mesureUniteIds:value
    })
  }  
  
  get adminFilterSearch() {
    return this.$store.myGetters.adminMesureTypeFilter.search
  }
  set adminFilterSearch(value) {
    this.$store.myActions.MESURETYPE_UPDATE_FILTER_ADM({
      search:value == null?"":value
    })
  } 
}
</script>
